
export const errorHandler = {
    // Error type messages
    contentPolicy: 'Content does not comply with platform policy, please modify and try again',
    safetyViolation: 'Content involves safety issues, please modify prompt and try again',
    noImageGenerated: 'Failed to generate image, please try modifying the prompt or regenerating',
    recitationConcern: 'Content may involve copyright issues, please modify prompt and try again',
    promptTooComplex: 'Prompt is too complex or contains conflicting requirements, please simplify and try again',
    rateLimit: 'Too many requests, please try again later',
    credits: 'Insufficient credits, please recharge and try again',
    timeout: 'Operation timed out, please try again',
    network: 'Network connection failed, please check your connection',
    networkError: 'Network connection failed, please check your connection',
    server: 'Internal server error, please try again later',
    auth: 'Authentication failed, please login again',
    notFound: 'Resource not found, possibly deleted',
    apiError: 'API call failed, please try again later',
    unknown: 'Unknown error, please try again later',
    
    // Video generation error messages
    videoGenerateRequestFailed: 'Video generation request failed',
    requestFailed: 'Request failed',
    generateFailed: 'Generation failed',
    generateTimeoutInfo: 'Generation timed out, you can check the results later in "Creation Records"',
    queryGenerateStatusFailed: 'Failed to query generation status',
    
    // HTTP error messages
    badRequest: 'Invalid request parameters',
    paymentRequired: 'Payment required to continue',
    accessDenied: 'Access denied, please check permissions',
    methodNotAllowed: 'Request method not allowed',
    conflict: 'Request conflict, resource may have been modified',
    internalServerError: 'Internal server error, please try again later',
    badGateway: 'Bad gateway, please try again later',
    serviceUnavailable: 'Service temporarily unavailable, please try again later',
    gatewayTimeout: 'Gateway timeout, please try again later'
  };
